export interface NavLink {
  text: string;
  url?: string;
  category?: string; // for search sub links
  Component?: () => JSX.Element[];
  sublinks?: NavLink[];
  testID?: string;
  activeUrls?: string[];
  isNew?: boolean;
}

export const SUB_BUY_LINKS = (isRoi?: boolean): NavLink[] => {
  const appendText = isRoi ? 'republic-of-ireland' : 'northern-ireland';

  return [
    {
      text: 'Residential',
      url: `/property-for-sale/${appendText}`,
      category: 'residential',
      testID: 'residentialSale',
    },
    {
      text: 'New Homes',
      url: `/new-developments/${appendText}`,
      category: 'newhomes',
      testID: 'newhomesSale',
    },
    {
      text: 'Commercial',
      url: `/commercial-property-for-sale/${appendText}`,
      category: 'commercial',
      testID: 'commercialSale',
    },
    {
      text: 'Auctions',
      url: `/auctions/${appendText}`,
      category: 'auctions',
      testID: 'auctionsSale',
    },
    {
      text: 'Agricultural',
      url: `/agricultural-for-sale/${appendText}`,
      category: 'agricultural',
      testID: 'agriculturalSale',
    },
    {
      text: 'Land & Sites',
      url: `/land-for-sale/${appendText}`,
      category: 'land',
      testID: 'landSale',
    },
  ];
};

export const SUB_RENT_LINKS = (isRoi?: boolean): NavLink[] => {
  const appendText = isRoi ? 'republic-of-ireland' : 'northern-ireland';

  return [
    {
      text: 'Residential',
      url: `/property-to-rent/${appendText}`,
      category: 'residential',
      testID: 'residentialRent',
    },
    {
      text: 'Student Rentals',
      url: `/student-rentals/${appendText}`,
      category: 'student',
      testID: 'studentRent',
    },
    {
      text: 'Holiday Homes',
      url: `/holiday-homes-to-rent/${appendText}`,
      category: 'holidayhomes',
      testID: 'holidayhomesRent',
    },
    {
      text: 'Commercial',
      url: `/commercial-property-to-rent/${appendText}`,
      category: 'commercial',
      testID: 'commercialRent',
    },
    {
      text: 'Agricultural',
      url: `/agricultural-to-rent/${appendText}`,
      category: 'agricultural',
      testID: 'agriculturalRent',
    },
    {
      text: 'Land & Sites',
      url: `/land-to-rent/${appendText}`,
      category: 'land',
      testID: 'landRent',
    },
  ];
};

export const BUY_LINKS_NI: NavLink = {
  text: 'Buy',
  testID: 'buyLink',
  sublinks: SUB_BUY_LINKS(),
};

export const BUY_LINKS_ROI: NavLink = {
  text: 'Buy',
  testID: 'buyLink',
  sublinks: SUB_BUY_LINKS(true),
};

export const RENT_LINKS_NI: NavLink = {
  text: 'Rent',
  testID: 'rentLink',
  sublinks: SUB_RENT_LINKS(),
};

export const RENT_LINKS_ROI: NavLink = {
  text: 'Rent',
  testID: 'rentLink',
  sublinks: SUB_RENT_LINKS(true),
};

export const NEW_HOMES_LINK: NavLink = {
  text: 'New Homes',
  url: '/new-homes/northern-ireland',
};

export const FIND_AGENTS_LINK: NavLink = {
  text: 'Find Agents',
  url: '/find-an-agent',
  activeUrls: [
    '/find-an-agent',
    '/estate-agents',
    '/letting-agents',
    '/student-letting-agents',
    '/commercial-estate-agents',
    '/new-homes-agents',
  ],
};

export const MORTGAGES_LINK: NavLink = {
  text: 'Mortgages',
  url: '/mortgages',
};

export const INSTANT_VALUATION_LINK: NavLink = {
  text: 'Instant Valuation',
  url: '/instant-valuation',
  isNew: true,
  testID: 'instantValLink',
};

export const AGENT_VALUATION_LINK: NavLink = {
  text: 'Agent Valuation',
  url: '/agent-valuation',
  isNew: true,
  testID: 'agentValLink',
};

export const ACCOUNT_LINKS = [
  {
    text: 'Account Overview',
    url: '/my/overview',
    testID: 'accountOverview',
  },
  {
    text: 'Favourites',
    url: '/my/favourites',
  },
  {
    text: 'Saved Searches',
    url: '/my/alerts',
  },
  {
    text: 'My Enquiries',
    url: '/my/enquiries',
  },
  {
    text: 'Notes',
    url: '/my/notes',
  },
  {
    text: 'Mortgage Pre-approval',
    url: '/my/preapproval',
  },
  {
    text: 'Pals & Sharing',
    url: '/my/pals',
  },
  {
    text: 'My Profile',
    url: '/my/profile',
  },
  {
    text: 'Logout',
  },
];

export const SIGN_IN_LINKS = [
  {
    text: 'Log In',
    url: '/login',
    testID: 'loginLink',
  },
  {
    text: 'Sign Up',
    url: '/register',
  },
];

export const TOP_LEVEL_SALE_LINKS = [BUY_LINKS_NI.text, BUY_LINKS_ROI.text];
export const TOP_LEVEL_RENT_LINKS = [RENT_LINKS_NI.text, RENT_LINKS_ROI.text];
export const SEARCH_LINKS = [...TOP_LEVEL_SALE_LINKS, ...TOP_LEVEL_RENT_LINKS];

export const STANDARD_LINKS = [
  BUY_LINKS_NI,
  RENT_LINKS_NI,
  NEW_HOMES_LINK,
  MORTGAGES_LINK,
  // INSTANT_VALUATION_LINK,
  // AGENT_VALUATION_LINK,
];

export const ROI_LINKS = [BUY_LINKS_ROI, RENT_LINKS_ROI, FIND_AGENTS_LINK];
